import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

function Paper(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement(StyledPaper, {
    className: className
  }, children);
}

var StyledPaper = styled.div.withConfig({
  displayName: "Paper__StyledPaper",
  componentId: "cp9itx-0"
})(["padding-top:1rem;padding-bottom:1rem;margin:1rem 0;box-shadow:0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12);border-radius:0.5rem;background-color:", ";"], function (props) {
  return props.theme.white;
});
Paper.propTypes = {
  /**
   * Children passed to the Paper.
   */
  children: PropTypes.node,

  /**
   * Classname that is passed to the Paper.
   */
  className: PropTypes.string
};
export default Paper;